<template>
  <!-- DIALOG -->
  <div>
    <div v-if="!definition"
    class="text-xs-center">
      <img src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="120px">
      <v-btn 
      depressed
      block
      large
      @click="$emit('selectDefinition', item)">
        Select item
      </v-btn>
    </div>
    <div v-else>
      
      <!-- Top Half -->
      <div class="crx-gradient-purple white--text pa-3">
        <div>
          <v-layout justify-center align-center column>
            <div class="text-uppercase">
              {{ definition.name }}
              <v-btn 
              @click="$emit('selectDefinition', item)"
              class="ma-0"
              icon
              depressed>
                <v-icon color="white">mdi-arrow-down-drop-circle-outline</v-icon>
              </v-btn>
            </div>
            <img src="@/assets/img/illustrations/cream.png" alt="cardboard box" width="120px">
          </v-layout>
        </div>

          <v-layout>
            <v-flex xs6 class="text-xs-center">
              <div class="caption white--text">
                Debit
              </div>
              <c-metric-selector
              :inventoryItemID="definition.id" 
              :realValue="totalFilled"
              :key="definition.id + 'a'"
              alwaysScale
              labelMode
              class="text-sans"
              ></c-metric-selector>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <div class="caption white--text">
                In stock
              </div>
              <c-metric-selector
              :inventoryItemID="definition.id" 
              :realValue="totalInStock"
              :key="definition.id + 'b'"
              alwaysScale
              labelMode
              class="text-sans font-weight-bold subheading"
              ></c-metric-selector>
            </v-flex>
          </v-layout>
          <v-progress-linear
          class="ma-0"
          v-model="percent"
          color="white"
          height="4"
          ></v-progress-linear>
          <div v-if="this.totalDebit > this.totalInStock"
          class="red--text caption">
            * Insufficient stock,
            short 
            <c-metric-selector
            :inventoryItemID="definition.id" 
            :realValue="this.totalDebit - this.totalInStock "
            :key="definition.id"
            alwaysScale
            labelMode
            class="text-sans"
            ></c-metric-selector>
          </div>
          <div v-else
          class="text-xs-center caption">
            {{ percent.toFixed(2) }}%
          </div>

      </div>
      <!-- End Top Half -->

      <!-- BATCH SELECTION -->

      <div class="pa-3">

        <div class="mt-3 subheading font-weight-bold text-sans">
          BATCHES
        </div>

        <!-- filter menu -->
        <div class="text-xs-right">
          <v-menu 
          bottom
          left
          transition="slide-y-transition"
          offset-y>
            <v-btn
              slot="activator"
              color="text"
              flat>
              <v-icon color="text">filter_list</v-icon>
              {{ sortOptions[sortIndex] }}
              <v-icon 
              small
              color="color1"
              :class="['sort-arrow visible transition2s', {'rotate': sortAscending}]">
                arrow_downward
              </v-icon>
            </v-btn>

            <v-list>
              <v-item-group 
              v-model="sortIndex"
              mandatory>
                <v-item
                  v-for="(n, index) in sortOptions"
                  :key="n">
                  <v-list-tile
                    v-ripple
                    slot-scope="{ active }"
                    :selected="active"
                    @click="clickSortHeader(index)"
                  >
                    {{ n }}
                    <v-icon 
                    small
                    color="color1"
                    :class="['sort-arrow', {'rotate': active && sortAscending}, {'visible': active }]">
                      arrow_downward
                    </v-icon>
                  </v-list-tile>
                </v-item>
              </v-item-group>
            </v-list>
          </v-menu>
        </div>
        <!-- end filter menu -->

        <batch-row
        v-for="item in paginatedArray" 
        :key="item.tempID" 
        :item="item"
        :inputs="inputs"
        >
        </batch-row>

        <div class="text-xs-center">
          <v-pagination
          v-if="paginationLength > 1"
          v-model="page"
          :length="paginationLength"
          circle>

          </v-pagination>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import BatchRow from './BatchRow'
import ListController from '@/mixins/ListController'

export default {
  props: ['vmode', 'item', 'inputs', 'inventoryView'],
  components: {
    BatchRow
  },
  mixins: [ListController],
  data () {
    return {
      sortOptions: [
        'Debit', 'Expiry date'
      ],
      sortIndex: 1,
      sortAscending: true,
      totalDebit: 0,
      items: []
    }
  },
  watch: {
    definition (nv) {
      this.$emit('update:inputs', {})
      this.items = Object.values(this.inventoryView).filter(item => item.inventory_item_id === this.definition.id)
    }
  },
  computed: {
    definition () {
      return this.$store.state.db.inventoryDefinitions.definitions[this.item.definitionId] || {}
    },
    totalFilled () {
      return Object.values(this.inputs).reduce((a, i) => a + i, 0) || 0
    },
    totalInStock () {
      return this.items.reduce((a, b) => +a + +b.quantity, 0)
    },
    percent () {
      var percent = 100 - (((this.totalInStock - this.totalFilled) / this.totalInStock) * 100)
      return isNaN(percent) ? 0 : percent
    }
  },
  methods: {
    sort (headerIndex, items, sortAscending) {
      if (headerIndex === 0) { // Debit Quantity
        return items.sort((a, b) => {
          var vA = this.inputs[a.id] || 0
          var vB = this.inputs[b.id] || 0
          return sortAscending ? vA - vB : vB - vA
          // return sortAscending ? a.name.localeCompare(b.name) : b.name.localeCompare(a.name)
        })
      } else if (headerIndex === 1) { // Expiry
        return items.sort((a, b) => {
          var expiryA = this.$store.state.db.inventoryArchive.archive[a.archive_id].expiry_date
          var expiryB = this.$store.state.db.inventoryArchive.archive[b.archive_id].expiry_date
          return sortAscending ? new Date(expiryA) - new Date(expiryB) : new Date(expiryB) - new Date(expiryA)
        })
      } else if (headerIndex === 2) { // Lead time
        return items.sort((a, b) => {
          return sortAscending ? a.lead_time - b.lead_time : b.lead_time - a.lead_time
        })
      }
    }
  },
  mounted () {
    this.items = Object.values(this.inventoryView).filter(item => item.inventory_item_id === this.definition.id)
  }
}
</script>

<style scoped lang="scss">
.mrow {
  cursor: pointer;
  position: relative;
  border-bottom: 1px solid #edeff2;
}
.mrow:hover {
  background: #fafbfc;
}
.selected-row {
  border-color: var(--v-color1-lighten3);;
}
.selected-row::before {
  background: var(--v-color1-base);
  height: 100%;
  width: 100%;
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  opacity: 0.1;
}
.purple-gradient-progress {
  border: thin solid;
  box-shadow: 0px 0px rgba(0,0,0,0.2);
  border-radius: 5px;

  & ::v-deep .v-progress-linear__bar__determinate {
    background: linear-gradient(215deg, #53a6f6, #8928d3);
  }
}
.table-flex-cell {
  display: flex;
  align-items: center;
}
.sort-arrow {
  opacity: 0;

  &.visible {
    opacity: 1;
  }
  &.rotate {
    transform: rotate( -180deg );
  }
}
</style>
